import React from 'react';
export const Footer = () => {
  return <footer className="py-12 px-6 border-t border-white/5 text-center" data-id="element-42">
      <div className="max-w-2xl mx-auto" data-id="element-43">
        <p className="text-parchment-dark text-sm font-light mb-4" data-id="element-44">
          The 3AM Mind-Quiet Script
        </p>
        <p className="text-parchment-dark/60 text-xs font-light" data-id="element-45">
          By Brianna Bermudez
        </p>
      </div>
    </footer>;
};